import React from "react";
import Login from "../containers/Login";
import NoNavLayout from "../layouts/NoNavLayout";

export const LoginPage = props => {
  document.title = props.title;
  return (
    <NoNavLayout>
      <Login />
    </NoNavLayout>
  );
};

export const LoginDebugPage = props => {
  document.title = props.title;
  return (
    <NoNavLayout>
      <Login debug={true} />
    </NoNavLayout>
  );
};

export default LoginPage;






// WEBPACK FOOTER //
// ./src/pages/LoginPage.js